import React from 'react';
import Navbar from '../components/Navbar';
import Main from '../components/Main';
import Footer from '../components/Footer';
const Home = () => {
    return (
        <div style={{}}>
           <Navbar />
           <Main />
           <Footer /> 
        </div>
    );
};

export default Home;